import { useSEO } from "@/hooks/use-seo";
import { Hero } from "@/components/home/Hero";
import { TrustStrip } from "@/components/home/TrustStrip";
import { ProblemSection } from "@/components/home/ProblemSection";
import { DifferenceSection } from "@/components/home/DifferenceSection";
import { PillarsSection } from "@/components/home/PillarsSection";
import { GlimpsesSection } from "@/components/home/GlimpsesSection";
import { InsightsTeaser } from "@/components/home/InsightsTeaser";
import { PropertyTypes } from "@/components/home/PropertyTypes";
import { EducationSection } from "@/components/home/EducationSection";
import { FAQSection } from "@/components/home/FAQSection";
import { FinalCTA } from "@/components/home/FinalCTA";

export default function HomePage() {
  useSEO(
    "ANFORD | Property Management That Thinks",
    "One intelligent platform to manage operations, understand performance and make better decisions across your property portfolio. Built for African real estate. Book a demo."
  );
  return (
    <>
      <Hero />
      <TrustStrip />
      <ProblemSection />
      <DifferenceSection />
      <PillarsSection />
      <GlimpsesSection />
      <InsightsTeaser />
      <PropertyTypes />
      <EducationSection />
      <FAQSection />
      <FinalCTA />
    </>
  );
}
